import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserLayout from '../layout/UserLayout';
import { useUpdatePasswordMutation } from '../../redux/api/userApi';
import MetaData from '../layout/MetaData';
import toast from 'react-hot-toast';

const UpdatePassword = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();
  const [updatePassword, { isLoading, error, isSuccess }] = useUpdatePasswordMutation();

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
    if (isSuccess) {
      toast.success('Password updated successfully');
      navigate('/me/profile');
    }
  }, [error, isSuccess, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    updatePassword({ oldPassword, password });
  };

  return (
    <UserLayout>
      <MetaData title="Update Password" />
      <div className="row wrapper">
        <div className="col-10 col-lg-6">
          <form className="shadow rounded bg-body" onSubmit={submitHandler}>
            <h2 className="mb-4 text-center">Update Password</h2>

            <div className="mb-4">
              <label htmlFor="old_password_field" className="form-label">Current Password</label>
              <input
                type="password"
                id="old_password_field"
                className="form-control"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                placeholder="Enter current password"
                required
              />
            </div>

            <div className="mb-4">
              <label htmlFor="new_password_field" className="form-label">New Password</label>
              <input
                type="password"
                id="new_password_field"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter new password"
                required
              />
            </div>

            <button type="submit" className="btn btn-primary w-100 py-2" disabled={isLoading}>
              {isLoading ? 'Updating...' : 'Update Password'}
            </button>
          </form>
        </div>
      </div>
    </UserLayout>
  );
};

export default UpdatePassword;